<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Relatório de <strong>Alunos Matriculados</strong></h4>

    <form @submit.prevent="generateReport">
      <div class="row">
        <div class="form-group col-md-6">

          <div class="mb-3">
            <label class="form-label">Turmas (Opcional)</label>
            <select v-model="team_ids" multiple class="form-control form-control-sm" style="height: 120px;">
              <option v-for="team in teams" :key="team.id" :value="team.id">
                {{ team.name }}
              </option>
            </select>
            <small class="text-muted">Segure Ctrl para selecionar mais de uma turma.</small>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="start_date" class="form-label">Data Inicial (Opcional)</label>
              <input type="date" v-model="start_date" class="form-control form-control-sm" id="start_date">
            </div>
            <div class="col-md-6 mb-3">
              <label for="end_date" class="form-label">Data Final (Opcional)</label>
              <input type="date" v-model="end_date" class="form-control form-control-sm" id="end_date">
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Formato</label>
            <select v-model="type_print" class="form-control form-control-sm">
              <option value="xlsx">Excel (.xlsx)</option>
              <option value="pdf">PDF</option>
            </select>
          </div>

          <div v-if="!loading" class="form-group text-center my-2">
            <button type="submit" class="btn btn-success btn-sm mx-2 text-uppercase">
              Gerar Relatório
            </button>
            <button type="reset" class="btn btn-secondary btn-sm text-uppercase" @click="clearForm">
              Limpar
            </button>
          </div>

          <LoadingPage v-else />

        </div>
      </div>
    </form>

    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
      VOLTAR
    </button>
  </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import { handleBlobError } from "@/helpers";

export default {
  name: "EnrolledStudentsReport",
  components: {
    LoadingPage,
  },
  data() {
    return {
      team_ids: [],
      start_date: "",
      end_date: "",
      type_print: "xlsx",
      loading: false,
      teams: [],
    };
  },
  methods: {
    async generateReport() {
      this.loading = true;

      const params = { type_print: this.type_print };
      if (this.team_ids.length) params.team_ids = this.team_ids.join(',');
      if (this.start_date) params.start_date = this.start_date;
      if (this.end_date) params.end_date = this.end_date;

      const ext = this.type_print === 'pdf' ? 'pdf' : 'xlsx';

      try {
        const response = await api.get("/exports/enrolled-students", {
          params,
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `relatorio_alunos_matriculados_${Date.now()}.${ext}`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        Toast.fire("Sucesso", "Relatório gerado com sucesso!", "success");
      } catch (error) {
        handleBlobError(error, (message) => {
          Toast.fire("Erro", message, "error");
        });
      } finally {
        this.loading = false;
      }
    },
    clearForm() {
      this.team_ids = [];
      this.start_date = "";
      this.end_date = "";
      this.type_print = "xlsx";
    },
    async getTeams() {
      try {
        const res = await api.get("/teams?page=0&perPage=99999&sortBy=name&forPagination=1");
        this.teams = res.data.data;
      } catch (error) {
        console.error("Erro ao buscar turmas:", error);
      }
    },
  },
  mounted() {
    this.getTeams();
  },
};
</script>

<style scoped>
</style>
